import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IUser } from '../../../lib/interfaces';
import { DS } from '../designTokens';
import { usePatientName } from '../hooks/usePatientName';

type Props = {
  open: boolean;
  patient: IUser;
  onCancel: () => void;
  onConfirm: () => void;
};

const EndCallDialog = ({ open, patient, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();
  const patientName = usePatientName(patient);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="video-end-title"
      aria-describedby="video-end-body"
    >
      <DialogTitle id="video-end-title" sx={{ fontWeight: 700 }}>
        {t('videoVisit.hangUp.title', { name: patientName })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="video-end-body">
          {t('videoVisit.hangUp.body', { name: patientName })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {/* Continuing is the safe choice, so it takes focus. */}
        <Button autoFocus onClick={onCancel} sx={{ textTransform: 'none' }}>
          {t('videoVisit.hangUp.cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            bgcolor: DS.hangUp,
            '&:hover': { bgcolor: DS.hangUp, filter: 'brightness(0.96)' },
          }}
        >
          {t('videoVisit.hangUp.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EndCallDialog;
